import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import PanelSubnavigation from './PanelSubnavigation';
import DraftRendererWithOptions from '../widgets/DraftRenderer';

import './panel-info.scss';

class PanelInfo extends PureComponent {
  render() {
    return (
      <div className={cn('panel panel-typography', { open: this.props.open })}>
        <div className="panel-scroll">
          <div className="static-section">
            <button
              className="close-panel"
              type="button"
              onClick={this.props.onCloseClick}
            />
          </div>

          {(!!this.props.story.content) &&
            <DraftRendererWithOptions
              content={JSON.stringify(this.props.story.content)}
            />
          }

          <div className="projects-info">
            <div className="static-section">
              <PanelSubnavigation
                onCloseClick={this.props.onCloseClick}
                program={this.props.story.programLink}
                links={this.props.links}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PanelInfo.propTypes = {
  story: PropTypes.object,
  links: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func
};

export default PanelInfo;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/PanelInfo.js